<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-data-table
        :headers="headers"
        :items="availableForms"
        :items-per-page="50"
        item-key="form_rowkey"
        fixed-header
        height="350px"
      >
        <template v-slot:item._actions="{ item }">
          <v-menu
            bottom
            close-on-click
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                Actions
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                link
              >
                <v-list-item-title
                  @click="doOpenPublishUrl(item)"
                >
                  Preview Form
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                link
              >
                <v-list-item-title
                  @click="doAssignForm(item)"
                >
                  Assign
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    _COMMIT_LOG, ACCT_GET_ACCOUNT_FORMS, FORM_GET_FORMS,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  import formService from '../../services/form.service'
  export default {
    name: 'PowAccountAssignForms',
    mixins: [basicMixin],

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'display_text',
          },
          {
            text: 'Actions',
            align: 'start',
            sortable: false,
            value: '_actions',
          },

        ],
      }
    },

    computed: {
      ...mapGetters({
        items: 'acctSelectedAccountForms',
        forms: 'forms',
        assignedForms: 'acctSelectedAccountForms',
        selectedAccount: 'acctSelectedAccount',
      }),
      availableForms () {
        const filteredforms = []
        for (let f = 0; f < this.forms.length; f++) {
          const form = this.forms[f]
          let formAssigned = false
          this.assignedForms.forEach((assigned) => {
            if (form.rowkey === assigned.form_rowkey) {
              formAssigned = true
            }
          })
          if (!formAssigned && (form.fk_store_key && (form.fk_store_key === this.selectedAccount.fk_store_key))) {
            console.log(`form ${form.display_text} has store_key ${form.fk_store_key} pushing to list while account has ${this.selectedAccount.fk_store_key} formAssigned: ${formAssigned}`)
            filteredforms.push(form)
          }
        }
        return filteredforms
      },

    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getForms: FORM_GET_FORMS,
        getAccountForms: ACCT_GET_ACCOUNT_FORMS,
      }),
      init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.getForms()
        this.getAccountForms({ rowkey: this.selectedAccount.rowkey })
        this.formMode = 'read'
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      async doOpenPublishUrl (item) {
        this.commitLog({ message: 'Opening publish URL from assigned form', item })
        // const returnedAccount = await this.getAccountByExtKey({ key: this.custId })
        // this.commitLog({ message: 'account returned from external key', record: returnedAccount })
        const url = `${item.publish_url}`
        window.open(url, '_blank')
      },
      async doAssignForm (item) {
        this.commitLog({ message: 'Assigning form', item })
        try {
          const { data } = await formService.assign(item.rowkey, {
            account_key: this.selectedAccount.rowkey,
          })
          this.commitLog({ message: 'payload from assigning the form', data })
          await this.getAccountForms({ rowkey: this.selectedAccount.rowkey })
        } catch (e) {
          this.commitLog({ message: 'exception caught when trying to assign form', error: e })
        }
      },

    },

  }
</script>

<style>
</style>
